import React, { memo, useCallback, useMemo } from 'react';
import Button from 'design-system/Button';
import { ButtonGroup } from 'design-system';
import { goBackToTopWithStops } from 'utils/navigationv6';
import { useMainStackNavigation } from 'utils/types/navigationV6';
import useFundPickerStore, { saveFundPicker, toggleFund } from 'features/invest/hooks/useFundPickerStore';
const FundPickerStockButton = ({ assetId }) => {
    const { isFundSelected, ignoreFunds, mode } = useFundPickerStore();
    const navigation = useMainStackNavigation();
    const isSelected = isFundSelected(assetId);
    const handlePress = useCallback(() => {
        toggleFund(assetId);
        if (mode === 'single') {
            saveFundPicker();
            goBackToTopWithStops(navigation, ['InvestAssetSwitch']);
            return;
        }
        navigation.goBack();
    }, [assetId, mode]);
    const title = useMemo(() => {
        if (mode === 'single') {
            return isSelected ? 'Remove fund from switching' : 'Pick fund for switching';
        }
        return isSelected ? 'Remove fund from allocation' : 'Pick fund for allocation';
    }, [isSelected, mode]);
    if (ignoreFunds.includes(assetId))
        return null;
    return (<ButtonGroup type="floating">
      <Button {...(isSelected ? { brandReversed: true } : { brand: true })} title={title} onPress={handlePress}/>
    </ButtonGroup>);
};
export default memo(FundPickerStockButton);
